var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSlider = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9038 15.8333V15H16.6538C16.7821 15 16.8997 14.9466 17.0065 14.8398C17.1133 14.733 17.1667 14.6154 17.1667 14.4871V5.51292C17.1667 5.38458 17.1133 5.26701 17.0065 5.16021C16.8997 5.0534 16.7821 5 16.6538 5H12.9038V4.16667H16.6538C17.0374 4.16667 17.3576 4.29514 17.6146 4.55208C17.8715 4.80903 18 5.12931 18 5.51292V14.4871C18 14.8707 17.8715 15.191 17.6146 15.4479C17.3576 15.7049 17.0374 15.8333 16.6538 15.8333H12.9038ZM10.0833 17.5V15.8333H4.34625C3.96264 15.8333 3.64236 15.7049 3.38542 15.4479C3.12847 15.191 3 14.8707 3 14.4871V5.51292C3 5.12931 3.12847 4.80903 3.38542 4.55208C3.64236 4.29514 3.96264 4.16667 4.34625 4.16667H10.0833V2.5H10.9167V17.5H10.0833Z",
    fill: "#1F1F1F"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSlider);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/slider.e6a55e7399fce81a8978ec9f6ea341a6.svg";